import { dataInfoCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconInfoCircle = /*#__PURE__*/createIcon(dataInfoCircle)
export default IconInfoCircle
